import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const HOUSEHOLD_KEY = "household";
const SET_PRIMARY_NETORK = "setPrimaryNetwork";
const SET_HEAD_OF_HOUSEHOLD = "setHeadOfHhousehold";
const SET_HOUSEHOLD_NAME = "setHouseholdName";
const REMOVE_FROM_HOUSEHOLD = "removeFromHoushold";
const GET_HOUSEHOLD_DATA_BY_USER_ID = "getHouseholdDataByUserID";

const householdProfileKeys = createKeys(
  featureKeys.HOUSEHOLD_PROFILE_FEATURE_KEY,
  {
    householdDetail: (userID) => [HOUSEHOLD_KEY, userID],
    setPrimaryNetwork: (householdID) => [SET_PRIMARY_NETORK, householdID],
    setHeadOfHousehold: (userID) => [SET_HEAD_OF_HOUSEHOLD, userID],
    setHouseholdName: (householdID) => [SET_HOUSEHOLD_NAME, householdID],
    removeFromHoushold: (userID) => [REMOVE_FROM_HOUSEHOLD, userID],
    getHouseholdDataByUserID: (userID) => [
      GET_HOUSEHOLD_DATA_BY_USER_ID,
      userID,
    ],
  }
);

export default householdProfileKeys;
